// Mapper: transporte LC_ListMonitoringJustifiedOut → dominio MonitoringJustifiedPage.
// Mantiene la UI desacoplada del DTO de la API y normaliza los valores ausentes.

import type {
  LC_MonitoringJustifiedItem,
  LC_ListMonitoringJustifiedOut,
  MonitoringJustified,
  MonitoringJustifiedPage,
} from '../types/monitoringJustified.types';


export function mapMonitoringJustified(item: LC_MonitoringJustifiedItem): MonitoringJustified {
  return {
    rut: item.employeeTaxIdentificationNumber ?? '',
    fullName: item.fullName ?? '',
    statusCode: item.statusCode ?? '',
  };
}

export function mapMonitoringJustifiedPage(
  out: LC_ListMonitoringJustifiedOut,
): MonitoringJustifiedPage {
  return {
    items: (out.items ?? []).map(mapMonitoringJustified),
    totalRecords: out.pagination?.totalRecords ?? 0,
  };
}
